<template>
  <v-container fill-height
  :style="{
  minHeight: $vuetify.breakpoint.xsOnly ? 'calc(100vh - 300px)' : 
  $vuetify.breakpoint.smOnly ? 'calc(100vh - 300px)' :
  'calc(100vh - 150px)'
}">
           <v-card  v-if="sendlinksuccess" width="900"  max-width="900" class="mx-auto mb-6 pa-4" :elevation="2" 
           style="border-radius:30px;box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.2) !important;">
        <v-card-title class="justify-center font-weight-bold text-sm-h5">{{
          this.lg_register.reset_title
        }}</v-card-title>
        <v-row>
           <v-col justify="center" align="center" cols="12">
        {{this.lg_register.reset_subtitle1}}
        </v-col>
        </v-row>

           <v-row>
           <v-col justify="center" align="center" cols="12">
        {{this.lg_register.reset_subtitle2}}
        </v-col>
        </v-row>

           <v-row>
           <v-col justify="center" align="center" cols="12">
        {{this.lg_register.reset_subtitle3}}
        </v-col>
        </v-row>

           <v-row>
           <v-col justify="center" align="center" cols="12" class="ml-n4 mt-n6">
           <v-btn
                text
                class="mb-1 blue--text text-decoration-underline slide-btn"
                width="300"
                height="40"
                 @click="onClickMenu('/login-account')"
              >
              {{ this.lg_register.reset_btn }}
              </v-btn>
        </v-col>
        </v-row>

         <v-row v-if="checklanguage == 'th'">
        <v-col justify="center" align="center" cols="12">
       ต้องการความช่วยเหลือหรือไม่? หากท่านมีคำถามใดๆ กรุณา  
          <span class="text-decoration-underline" v-bind:style="{ cursor: 'pointer'}" @click="onClickMenu('/contact')">ติดต่อเรา</span>  
        </v-col>
        </v-row>

        <v-row v-else>
        <v-col justify="center" align="center" cols="12">
        Need help getting started?
        <span class="text-decoration-underline" v-bind:style="{ cursor: 'pointer'}" @click="onClickMenu('/contact')"> Contact Support</span>
        if you have any questions. 
        </v-col>
        </v-row>
      </v-card>

      <!-- OTP Section - แสดงเมื่อ otpDlg = true -->

  <v-card v-else-if="otpDlg" max-width="900" class="mx-auto mb-6 pa-4" :elevation="2" style="border-radius:30px;box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.2) !important;">
    
    <!-- Back button -->
    <div class="pa-4 pb-0">
      <v-btn icon small @click="cancelOtp">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </div>

    <v-card-text class="text-center px-8 pt-2 pb-6">
      
      <!-- Title v-bind:style="{ color: '#215295' }"-->
      <h2 class="otp-title mb-3" >{{ this.lg_register.verify_email_title }}</h2>

      <!-- Subtitle -->
      <p class="otp-subtitle mb-6">
       {{ this.lg_register.wesend_digit_code }} <strong>{{ maskEmail(account.username) }}</strong>.<br/>
         {{ this.lg_register.enter_finish_register }}
      </p>

      <!-- Label -->
      <div class="text-left mb-3">
        <span class="otp-label">{{ this.lg_register.verification_code }}</span>
      </div>

      <!-- OTP Inputs -->
         <v-card-text class="mt-4">
      <div class="d-flex justify-center" style="gap: 10px;">
 <input
        v-for="(digit, index) in otpDigits"
        :key="'otp-' + index"
        :ref="'otp_' + index"
        v-model="otpDigits[index]"
        type="tel"
        maxlength="1"
        class="otp-box"
        @input="onOtpInput(index)"
        @keydown="onOtpKeydown($event, index)"
        @paste="onOtpPaste($event, index)"
        />

      </div>
      <div v-if="otpError" class="red--text text-center mt-3 caption">
        {{ otpError }}
      </div>
    </v-card-text>

      <!-- Expire text -->
      <div class="text-left otp-expire mb-6">
        {{ this.lg_register.code_expire }} {{ formattedTimeCode_Expire }} {{ this.lg_register.minutes }}
      </div>

      <!-- Verify Button -->
      <v-btn
        block
        depressed
        large
        :disabled="otpDigits.join('').length < 6 || btntoo_many_attempts || (totalSecondscode_expire <= 0)"
        v-bind:style="{ minWidth: 'auto', backgroundColor: '#04182D' }"
        class="white--text mb-4 slide-btn"
        @click="confirmOtp()"
       :class="{ 'custom-disabled': otpDigits.join('').length < 6 || btntoo_many_attempts || (totalSecondscode_expire <= 0) }"
      >
        {{ this.lg_register.verify }}
      </v-btn>

      <!-- Resend -->
      <div class="otp-resend-wrapper">
    <span v-if="countdown > 0" class="otp-countdown">
      {{ this.lg_register.resend_code }} {{ countdown }} {{ this.lg_register.second }}
    </span>
     <v-btn 
     v-else
      class="otp-resend"
      @click="handleResend()"
       :class="{ 'custom-disabled': btntoo_many_attempts }"
       text
      color="blue"
      :disabled="btntoo_many_attempts"
    >
      Resend Code
    </v-btn>
  </div>

    </v-card-text>
  </v-card>

      <v-card v-else width="900"  max-width="900" class="mx-auto mb-6 pa-4" :elevation="2" style="border-radius:30px;box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.2) !important;">
        <!-- v-bind:style="{ color: '#215295' }" -->
        <v-card-title class="justify-center font-weight-bold text-sm-h5"  >
          {{ this.lg_register.title }}
        </v-card-title>
         <v-row>
           <v-col justify="center" align="center" cols="12">
        {{this.lg_register.subtitle1}}
        </v-col>
        </v-row>
        <!-- <v-divider></v-divider> -->
        <v-card-text>
          <v-form @submit.prevent="submit" ref="form" class="custom-padding-form">
            <v-row>
             <v-col align="center" justify="center"  cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
            <v-text-field
              dense
              outlined
              hide-details
              :label="this.lg_register.txt_fname"
              :placeholder="this.lg_register.txt_fname"
              v-model="account.acc_fname"
              required
              :rules="commonRules"
               prepend-inner-icon="mdi-account-outline"
            ></v-text-field>
              </v-col>
               <v-col align="center" justify="center"  cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
            <v-text-field
              dense
              outlined
              hide-details
              :label="this.lg_register.txt_lname"
              :placeholder="this.lg_register.txt_lname"
              v-model="account.acc_lname"
              required
              :rules="commonRules"
               prepend-inner-icon="mdi-account-outline"
            ></v-text-field>
            </v-col>
              </v-row>

              <v-row>
             <v-col align="center" justify="center"  cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
            <v-text-field
              dense
              outlined
              hide-details
              :label="this.lg_register.email"
              :placeholder="this.lg_register.email_place"
              v-model="account.username"
              required
              :rules="emailRules"
               prepend-inner-icon="mdi-email-outline"
            ></v-text-field>
             </v-col>
               <v-col align="center" justify="center"  cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
                  <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <!-- v-model="dateFormatted" -->
                  <!-- v-model="account.acc_birth" -->
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    :rules="dateOfBirthRules"
                    required
                      dense
                      outlined
                      hide-details
                      v-model="dateFormatted"
                      :label="lg_register.dtp_birthday"
                      persistent-hint
                       prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      @blur="date = parseDate(dateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
                 </v-col>
              </v-row>

                 <v-row>
             <v-col align="center" justify="center"  cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
            <v-text-field
              dense
              outlined
              hide-details
              v-model="account.password"
              :label="this.lg_register.txt_password"
              :placeholder="this.lg_register.txt_password"
              :rules="passwordRules"
              :append-icon="e1 ? 'visibility' : 'visibility_off'"
              @click:append="e1 = !e1"
              :type="e1 ? 'password' : 'text'"
              prepend-inner-icon="mdi-lock"
            ></v-text-field>
              </v-col>
               <v-col align="center" justify="center"  cols="12" xl="6" lg="6" md="6" sm="6" xs="12">

            <v-text-field
              dense
              outlined
              hide-details
              :label="this.lg_register.txt_password_confirm"
              :placeholder="this.lg_register.txt_password_confirm"
              :append-icon="e2 ? 'visibility' : 'visibility_off'"
              @click:append="e2 = !e2"
              :type="e2 ? 'password' : 'text'"
              v-model="account.password_confirm"
              :rules="passwordConfirmRules"
              required
              prepend-inner-icon="mdi-lock"
            ></v-text-field>
              </v-col>
              </v-row>

            <!-- <v-divider></v-divider> -->
             <!-- <v-row>
           <v-col justify="center" align="center" cols="12">
        {{ this.lg_register.subtitle2 }}
        </v-col>
        </v-row> -->

        <v-row v-if="checklanguage == 'th'">
        <v-col justify="center" align="center" cols="12">
          เมื่อดำเนินการต่อ คุณยอมรับ  
          <span class="text-decoration-underline" v-bind:style="{ cursor: 'pointer'}"  @click="showPrivacyPolicy_1">{{ this.lg_footer.privacy_policy }}</span>  
          และ
           <span class="text-decoration-underline" v-bind:style="{ cursor: 'pointer'}"  @click="showDmeetsdocx_4">{{ this.lg_footer.terms_and_conditions }}</span>  
          ของ Dmeets
        </v-col>
        </v-row>

        <v-row v-else>
        <v-col justify="center" align="center" cols="12">
         By proceeding, I agree to Dmeets’s  
           <span class="text-decoration-underline" v-bind:style="{ cursor: 'pointer'}"  @click="showPrivacyPolicy_1">{{ this.lg_footer.privacy_policy }}</span>  
         and
          <span class="text-decoration-underline" v-bind:style="{ cursor: 'pointer'}"  @click="showDmeetsdocx_4">{{ this.lg_footer.terms_and_conditions }}</span>
        </v-col>
        </v-row>

            <!-- <span>{{ account }}</span> -->
            <v-layout justify-center class="mt-5">
               <v-btn
                type="submit"
                class="mb-1 white--text slide-btn"
                width="300"
                height="40"
                v-bind:style="{ minWidth: 'auto', backgroundColor: '#04182D' }"
                :class="{ 'custom-disabled': btntoo_many_attempts }"
                outlined
                :disabled="btntoo_many_attempts"
              >
              {{ this.lg_register.btn_register }}
              </v-btn>
              <!-- <v-btn @click.prevent="registerMember" color="success"
                >Register</v-btn
              > -->
            </v-layout>

             <v-row class="mt-4">
        <v-col justify="center" align="center" cols="12">
        {{ this.lg_register.already_have_an_account }}
           <span class="text-decoration-underline" v-bind:style="{ cursor: 'pointer'}"  @click="onClickMenu('/login-account')">{{ this.lg_register.login_here }}</span>  
       
        </v-col>
        </v-row>
          </v-form>
        </v-card-text>
      </v-card>

    <!-- Alert Dialog -->
    <v-dialog v-model="alertDlg" width="unset">
      <v-card>
        <v-card-title class="headline">{{
          this.titleMessageAlert
        }}</v-card-title>

        <v-card-text class="body">
          {{ this.messageAlert }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
            @click="alertDlg = false"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            Close
          </v-btn>

          <!-- <v-btn outlined color="error" text @click="confirmDelete">
            Confirm
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Alert Dialog -->

    <!-- Complete Dialog -->
    <v-dialog v-model="completeDlg" max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          this.titleMessageAlert
        }}</v-card-title>

        <v-card-text class="body">
          {{ this.messageAlert }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
            @click="onclickcompleteDlg()"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            Close
          </v-btn>

          <!-- <v-btn outlined color="error" text @click="confirmDelete">
            Confirm
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Complete Dialog -->

    <!-- OTP Dialog -->
<!-- <v-dialog v-model="otpDlg" persistent max-width="400">
  <v-card class="pa-4">
    <v-card-title class="justify-center text-h6 font-weight-bold">
      ยืนยัน OTP
    </v-card-title>
    <v-card-subtitle class="text-center mt-1">
      กรุณากรอกรหัส OTP 6 หลักที่ส่งไปยัง<br/>
      <strong>{{ account.username }}</strong>
    </v-card-subtitle>

    <v-card-text class="mt-4">
      <div class="d-flex justify-center" style="gap: 10px;">
        <v-text-field
          v-for="(digit, index) in otpDigits"
          :key="index"
          :ref="`otp_${index}`"
          v-model="otpDigits[index]"
          maxlength="1"
          outlined
          dense
          hide-details
          class="otp-input"
          style="max-width: 48px; text-align: center;"
          @input="onOtpInput(index)"
          @keydown="onOtpKeydown($event, index)"
          @paste="onOtpPaste($event)"
        />
      </div>
      <div v-if="otpError" class="red--text text-center mt-3 caption">
        {{ otpError }}
      </div>
    </v-card-text>

    <v-card-actions class="justify-center pb-4">
      <v-btn text color="grey" @click="cancelOtp">ยกเลิก</v-btn>
      <v-btn color="primary" :disabled="otpDigits.join('').length < 6" @click="confirmOtp">
        ยืนยัน
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog> -->

    <LoadingDialog></LoadingDialog>
  </v-container>
</template>

<script>
import api from "@/services/api";
import LoadingDialog from "@/components/cards/LoadingDialog";
import { server } from "../services/constants";
import { feature } from "../services/constants";
import { lg_register } from "./language/lg_register";
import { lg_footer } from "./language/lg_footer.js";

export default {
  data(vm) {
    // const d = new Date();
    // let nd = (d.getFullYear()+543) + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    // alert(text);
    return {
      countdownInterval: null,
      clickcountvaerify:0,
      btntoo_many_attempts:false,
      totalSecondscode_expire: 300,
      timercode_expire: null,
      otp_number:'',
      countdown: 45,
      timer: null,
      isPasting: false,
      otpDlg: false,
      otpDigits: ['', '', '', '', '', ''],
      otpError: '',
      otpResolve: null,
      sendlinksuccess:false,
      checklanguage:"",
      isRegister: false,
      alertDlg: false,
      completeDlg: false,
      myToggle: true,
      geust_id: "",
      geust_name: "",
      geust_ckeck: false,
      company_code: "",
      show_department: false,
      account: {
        username: "",
        password: "",
        password_confirm: "",
        company_id: 0,
        department_id: 10,
        acc_fname: "",
        acc_lname: "",
        acc_fullname: "",
        acc_id_card: "",
        acc_tel: "",
        acc_plan:"ENTERPRISE",
        acc_birth: null,
        role: "Member",
      },
      titleMessageAlert: "",
      messageAlert: "",
      date: vm.formatDateshowselect(new Date().toISOString().substr(0, 10)),
      dateFormatted: vm.formatDateshowselect(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      mDataArray: [],
      mDataArrayGuest: [],
      mDataArrayDepartment: [],
      valid: false,
      e1: true,
      e2: true,
      isShowPassword: false,
      commonRules: [(v1) => !!v1 || this.lg_register.rules_commond],
      passwordRules: [
        (v1) => !!v1 || this.lg_register.rules_password,
        (v2) =>
          !!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^()=+/_-])[A-Za-z\d@$!%*?&^()=+/_-]{8,}$/.test(
            v2
          ) || this.lg_register.rules_password2,
      ],
      passwordConfirmRules: [
        (v1) =>
          this.account.password == this.account.password_confirm ||
          this.lg_register.rules_password_confirm,
      ],
      phoneRules: [(v1) => /^\d{10}$/.test(v1) || this.lg_register.rules_phone],
      codeRules:"",
      emailRules: [
        (v1) =>
          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
            v1
          ) || this.lg_register.rules_email,
      ],
      dateOfBirthRules: [
  (v1) => {
    const today = new Date();
    const dob = new Date(this.date); 
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age >= 18 || this.lg_register.validatedate_of_birth;
  },
],
    };
  },

  beforeCreate() {
    this.$store.state.page_reload = false;

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_register = lg_register.register_th)
      : (this.lg_register = lg_register.register_en);


    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_footer = lg_footer.lg_footer_th)
      : (this.lg_footer = lg_footer.lg_footer_en);
      

    // console.log("lg_register: " + JSON.stringify(this.lg_register));
  },

  computed: {
     formattedTimeCode_Expire() {
      const minutes = Math.floor(this.totalSecondscode_expire / 60)
      const seconds = this.totalSecondscode_expire % 60

      return `${minutes}:${seconds.toString().padStart(2, '0')}`
    },
    widthcard() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "width:80%";
        case "sm":
          return "width:70%";
        case "md":
          return "width:70%";
        case "lg":
          return "width:60%";
        case "xl":
          return "width:50%";
      }
    },
    buttonsmall() {
      if (this.$vuetify.breakpoint.name === "xs") {
        return true;
      }
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  components: {
    LoadingDialog,
  },
  async mounted() {
    // alert(new Date(1772004047378).toLocaleString());
    //  alert(new Date(Date.now()).toLocaleString());
    const userId = localStorage.getItem(server.USER_ID);
       if (userId && api.isLoggedIn()) {
      this.$router.push("/listroom");
      return;
    }
    this.checklanguage = localStorage.getItem(feature.LANGUAGE);
    localStorage.setItem(server.MEET_STA, "false");
    this.loadGuest();
    this.loadCompany();
    clearInterval(this.timercode_expire);
    clearInterval(this.timer);
    this.checkDisableStatus();
  },

  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  methods: {
   async triggerDisable() {
      const expireTime = Date.now() + (5 * 60 * 1000) // 5 นาที
      sessionStorage.setItem('register_disable_expire', expireTime);

      this.btntoo_many_attempts = true;
      await this.startCountdowntoo_many_attempts();
    },

 async checkDisableStatus() {
  const expireTime = Number(sessionStorage.getItem('register_disable_expire'));

  if (!expireTime) return;

  if (Date.now() < expireTime) {
    this.btntoo_many_attempts = true;
   await this.startCountdowntoo_many_attempts();
  } else {
   await this.clearDisable();
  }
},

async startCountdowntoo_many_attempts() {
  clearInterval(this.countdownInterval)

  this.countdownInterval = setInterval(async() => {
    const expireTime = Number(sessionStorage.getItem('register_disable_expire'))

    if (!expireTime || Date.now() >= expireTime) {
     await this.clearDisable();
    }
  }, 1000)
},

   async clearDisable() {
  this.btntoo_many_attempts = false;
  sessionStorage.removeItem('register_disable_expire');
  clearInterval(this.countdownInterval);
  this.countdownInterval = null;
},
     maskEmail(email) {
    if (!email) return ''

    const [name, domain] = email.split('@')
    if (!name || !domain) return email

    if (name.length <= 2) {
      return name[0] + '*@' + domain
    }

    return (
      name[0] +
      '*'.repeat(name.length - 2) +
      name[name.length - 1] +
      '@' +
      domain
    )
  },
     startCountdownCode_Expire() {
       this.clearTimerCode_Expire();
      this.totalSecondscode_expire = 300;
      this.timercode_expire = setInterval(() => {
        if (this.totalSecondscode_expire > 0) {
          this.totalSecondscode_expire--
        } else {
        this.clearTimerCode_Expire();
        }
      }, 1000)
    },
     clearTimerCode_Expire() {
      // if (this.timercode_expire) {
        clearInterval(this.timercode_expire)
        this.timercode_expire = null
      // }
    },
    startCountdown() {
       this.clearTimer();
      this.countdown = 45;
      this.clearTimer();
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.clearTimer();
        }
      }, 1000)
    },
    clearTimer() {
      // if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      // }
    },
   async handleResend() {
      // TODO: เรียก API ส่ง OTP ที่นี่
      this.$emit('resend');
     await this.openOtpDialog();
    },
async openOtpDialog() {
  this.$store.state.loadMenu=true;
  this.clickcountvaerify = 0;
  this.otpDigits = ['', '', '', '', '', ''];
  this.otpError = '';

     const result = await api.sendMailforVerifyaccount(this.account);
     if(result.status === 200 || result.status === 201){
      // result.data
      this.otp_number = result.data.otp_number;
this.$swal.close(); 
   
  this.otpDlg = true;
  this.startCountdown();
  this.startCountdownCode_Expire();

  this.$nextTick(() => {
    setTimeout(() => {
      const firstEmpty = this.otpDigits.findIndex(d => !d);
      const index = firstEmpty !== -1 ? firstEmpty : 0;
      this.focusInput(index);
    }, 200); 
  });
  this.$store.state.loadMenu=false;
  return new Promise((resolve) => {
    this.otpResolve = resolve;
  });
    }else{
  this.$store.state.loadMenu=false;
  this.$swal.close(); 
  this.titleMessageAlert = "Send Email";
  this.messageAlert =  "Send Email Fail!!";
  this.completeDlg = true;
    }
},

focusFirstEmpty() {
  const firstEmpty = this.otpDigits.findIndex(d => !d);
  const index = firstEmpty !== -1 ? firstEmpty : 0;

  const input = this.$refs['otp_' + index];
  if (input && input[0]) {
    input[0].focus();
    input[0].select();
  }
},
onFocus(index) {
  this.focusInput(index);
},
onOtpInput(index) {
  let val = this.otpDigits[index] || ''
  val = val.replace(/\D/g, '').slice(-1)

  this.$set(this.otpDigits, index, val)

  if (val && index < 5) {
    this.focusInput(index + 1)
  }

},
focusInput(index) {
  this.$nextTick(() => {
    const ref = this.$refs['otp_' + index];
    const el = Array.isArray(ref) ? ref[0] : ref;
    if (el) el.focus();
  });
},

onOtpKeydown(event, index) {
  if (event.key === 'Backspace') {

    if (!this.otpDigits[index] && index > 0) {
      this.focusInput(index - 1);
    } else {
      this.$set(this.otpDigits, index, '');
    }

  }
},

onOtpPaste(event, index) {
  event.preventDefault();
  this.isPasting = true;

  const pasteData = (event.clipboardData || window.Clipboard)
    .getData('text')
    .trim()
    .replace(/\D/g, '')
    .slice(0, 6)

  if (!pasteData) return

  this.otpDigits = ['', '', '', '', '', '']

  this.$nextTick(() => {
    for (let i = 0; i < 6; i++) {
      const ref = this.$refs['otp_' + i]
      const el = Array.isArray(ref) ? ref[0] : ref
      if (el) el.value = ''
    }

    const newDigits = ['', '', '', '', '', '']
    pasteData.split('').forEach((digit, i) => {
      const targetIndex = index + i
      if (targetIndex < newDigits.length) {
        newDigits[targetIndex] = digit
      }
    })

    this.otpDigits = newDigits

    this.$nextTick(() => {
      for (let i = 0; i < 6; i++) {
        const ref = this.$refs['otp_' + i]
        const el = Array.isArray(ref) ? ref[0] : ref
        if (el) el.value = this.otpDigits[i]
      }

      const lastFilledIndex = Math.min(index + pasteData.length - 1, this.otpDigits.length - 1)
      const ref = this.$refs['otp_' + lastFilledIndex]
      const el = Array.isArray(ref) ? ref[0] : ref
      if (el) el.focus()
       this.isPasting = false;
    })
     this.isPasting = false;
  })
},


async confirmOtp() {
  const otp = this.otpDigits.join('');
  //   console.log(otp);
  //  console.log(this.otp_number);
  //  console.log(this.totalSecondscode_expire);
  if (otp.length < 6) {
    this.otpError = `${this.lg_register.pls_enter_full_digit}`;
    return;
  }
  
  if(this.totalSecondscode_expire == 0){
  this.otpError = `${this.lg_register.code_expire_pls_resend}`;
    return;
  }
  
  if(otp == this.otp_number){
    this.clickcountvaerify = 0;
  // this.otpDlg = false;
  if (this.otpResolve) this.otpResolve({ confirmed: true, otp });
   }else if(this.clickcountvaerify >= 5){
    this.otpError = `${this.lg_register.too_many_attempts}`;
    this.btntoo_many_attempts = true;
    await this.triggerDisable();
    this.clickcountvaerify = 0;
    return;
    
   }
   else{
    this.clickcountvaerify++;
    this.otpError = `${this.lg_register.incorrect_code}`;
    return;
   }
  
},

cancelOtp() {
  this.otpDlg = false;
  this.sendlinksuccess = false;
  if (this.otpResolve) this.otpResolve({ confirmed: false, otp: '' });
},
    onChangeDTP() {
      // alert(this.value);
    },
    async checkCompany() {
      if(this.company_code.length > 0) {
      //    this.codeRules = [
      //   (v1) =>
      //     /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/.test(v1) ||
      //     this.lg_register.rules_code,
      // ];
    this.codeRules = [
        (v1) =>
          /^(?=.*[A-Za-z])[A-Za-z\d]{6,}$/.test(v1) ||
          this.lg_register.rules_code,
      ];
      }
      
      
      // alert("checkCompany");
      // console.log("checkCompany:" + JSON.stringify(this.mDataArray));
      // console.log("checkCompany company_code:" + this.company_code);
      const result_code = await api.checkByCompanyCode(this.company_code);
      // console.log("checkCompany company_code:" + JSON.stringify(result_code));
      if (result_code.data != null) {
        // alert("Company:" + result_code.data.id);
        this.account.company_id = result_code.data.id;
        this.account.acc_plan = "PREMIUM";
        this.account.role = "Member";
        this.show_department = true;
        this.loadDepartment(result_code.data.id);
      } else {
        // alert("null");
        this.account.acc_plan = "ENTERPRISE";
        this.account.role = "Member";
        this.account.company_id = this.geust_id;
        this.show_department = false;
      }
      // this.mDataArray.forEach((element) => {
      //   if (element.company_code == this.company_code) {
      //     // alert("Company:" + element.id);
      //     this.account.company_id = element.id;
      //     this.account.role = "Member";
      //     this.show_department = true;
      //     this.loadDepartment(element.id);
      //   }
      // });
      // if (this.account.company_id == 0) {
      //   this.account.role = "Guest";
      //   this.account.company_id = this.geust_id;
      //   this.show_department = false;
      // }
      // console.log("checkCompany company_code:" + this.account.company_id);
    },
    changeDepartment(selectObj) {
      // console.log(selectObj);
      // alert(selectObj);
      this.account.department_id = selectObj;
    },
    async changeCompany(selectObj) {
      // console.log(selectObj)
      this.loadDepartment(selectObj);
    },
    async loadDepartment(id) {
      // console.log("loadDepartment")
      let result = await api.getAllDepartmentByCompanyId(id);
      // console.log(result)
      this.mDataArrayDepartment = result.data;
      // console.log(JSON.stringify(result.data));
    },
    async loadGuest() {
      this.mDataArrayGuest = [];

      let result = await api.getCompanyGuestId();
      // console.log("loadGuest : " + JSON.stringify(result.data));
      this.mDataArrayGuest = result.data.rows;

      // console.log("loadGuest : " + this.mDataArrayGuest[0].id);
      // console.log("loadGuest : " + this.mDataArrayGuest[0].company_name);
      // console.log("loadGuest2 : " + JSON.stringify(result.data.id));
      this.geust_id = this.mDataArrayGuest[0].id;
      this.geust_name = this.mDataArrayGuest[0].company_name;
      this.department_id = 10;
    },
    onChangeToggle() {
      if (this.myToggle == true) {
        this.account.role = "Member";
      } else {
        this.account.role = "Member";
        this.account.company_id = this.geust_id;
      }
      // alert(this.myToggle);
      // alert(this.account.role);
    },
    onclickcompleteDlg() {
      this.completeDlg = false;
      this.$router.push("/");
    },
    async submit() {
      //Code_DCM
  //     console.log(this.date);
  // console.log(this.dateFormatted);
      // console.log("submitCompany :" + JSON.stringify(this.account));

      if (this.$refs.form.validate()) {
        this.account.acc_fullname = `${this.account.acc_fname}  ${this.account.acc_lname}`;
        this.$store.state.loadMenu = true;
        // this.$swal.showLoading();

        this.titleMessageAlert = this.lg_register.dialog_check_data;

        // alert(this.company_code.length); 
        // if (this.company_code.length != 6 && this.company_code.length > 0) {
        //   this.messageAlert = this.lg_register.dialog_company_code;
        //   this.alertDlg = true;
        //   this.$store.state.loadMenu = false;
        //   return;
        // }

        const result = await api.checkRegister(this.account.username);
       
        // alert(JSON.stringify(result.data));
        if (result.data != null) {
          this.messageAlert = this.lg_register.dialog_email_used;
          this.alertDlg = true;
          this.$store.state.loadMenu = false;
          this.$swal.close(); 
          return;
        }
        this.account.acc_birth = this.date;
        // alert(JSON.stringify(this.account));
        // if (this.account.company_id == 0 && this.account.role == "Member") {
        //   this.messageAlert = "กรุณาเลือกบริษัท";
        //   this.alertDlg = true;
        //   this.$store.state.loadMenu = false;
        //   return;
        // }

        if (this.account.username == "") {
          this.messageAlert = this.lg_register.dialog_empty_email;
          this.alertDlg = true;
          this.$store.state.loadMenu = false;
          this.$swal.close(); 
          return;
        }

        if (this.account.password == "") {
          this.messageAlert = this.lg_register.dialog_empty_password;
          this.alertDlg = true;
          this.$store.state.loadMenu = false;
          this.$swal.close(); 
          return;
        }

        if (this.account.password != this.account.password_confirm) {
          this.messageAlert = this.lg_register.dialog_empty_password_confirm;
          this.alertDlg = true;
          this.$store.state.loadMenu = false;
          this.$swal.close(); 
          return;
        }

   this.$store.state.loadMenu=false;
  const otpResult = await this.openOtpDialog();

  if (!otpResult.confirmed) {
    this.$swal.close(); 
    this.$store.state.loadMenu = false;
    return; 
  }
  

  
  // return;
  // this.$swal.showLoading();

        const result_resister = await api.register(this.account);
        this.$swal.close();
        // alert(JSON.stringify(result_resister));
        if (result_resister != null) {
          // alert("result_resister.data != null");
          this.isRegister = true;
          // this.titleMessageAlert = this.lg_register.dialog_save;
          // this.messageAlert = this.lg_register.dialog_save_success;
          // this.completeDlg = true;
            this.otpDlg = false;
           this.sendlinksuccess = true;
          // this.$router.push("/");
          this.$store.state.loadMenu = false;
          // this.$store.dispatch({
          //                           type: 'doLogin',
          //                           username: this.account.username,
          //                           password: this.account.password,
          //                           rememberme:false,
          //                         }).then((data) => {
          //                                   this.$store.state.loadMenu = false;
          //                                   if(data==false){
          //                                     this.$router.push("/login-account").catch(()=>{});
          //                                   }
          //                         });
        } else {
          // alert("result_resister.data == null");
          this.titleMessageAlert = this.lg_register.dialog_save;
          this.messageAlert = this.lg_register.dialog_save_fail;
          this.$store.state.loadMenu = false;
        }
      }
    },
    async loadCompany() {
      let result = await api.getCompanyNotGuest();
      this.mDataArray = result.data;
      // console.log(JSON.stringify(result.data));
    },
    formatDate(date) {
      if (!date) return null;

      // const [year, month, day] = date.split("-");
      // return `${day}-${month}-${parseInt(year)+0}`;
        const [year, month, day] = date.split("-");
      return `${parseInt(year)+0}-${month}-${day}`;
    },
    formatDateshowselect(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${parseInt(year)+0}-${month}-${day}`;
    },
    parseDate(date) {
      if (!date) return null;

      // const [day, month, year] = date.split("/");
      // return `${day.padStart(2,'0')}-${month.padStart(2,'0')}-${year}`;
       const [year, month, day] = date.split("-");
      return `${parseInt(year)+0}-${month}-${day}`;
    },
       showPrivacyPolicy_1() {
      window.open(`http://${window.location.host}/privacy-policy`);
    },
    showDmeetsdocx_4() {
       if(this.checklanguage == "th"){
       window.open(`http://${window.location.host}/DCM_Terms_and_Conditions_(TH).pdf`);
      }else{
       window.open(`http://${window.location.host}/DCM_Terms_and_conditions_(ENG).pdf`);
      }
    },
     onClickMenu(link) {
      this.$router.push(link).catch((err) => {});
    },
  },
};
</script>

<style>
.v-progress-circular {
  margin: 1rem;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: rgb(59, 163, 236);
  color: white;
  border-radius: 16px;
  padding: 20px 20px 20px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: rgb(59, 163, 236);
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

@media (min-width: 960px) {
  .register-container {
    margin-top: 2rem
  }
}
.otp-box {
  width: 48px;
  height: 56px;
  border: 2px solid #bbb;
  border-radius: 12px;
  text-align: center;
  font-size: 1.4rem;
  font-weight: 600;
  color: #1a1a2e;
  outline: none;
  transition: border-color 0.2s;
  background: #fff;
}

.otp-box:focus {
  border-color: #1867c0; /* สีฟ้า Vuetify */
  border-width: 2px;
}
.custom-disabled.v-btn.v-btn--disabled {
  background-color: #9e9e9e !important;
  color: #ffffff !important;
  opacity: 1 !important; /* กัน Vuetify ลดความจาง */
}
</style>
